import { render, staticRenderFns } from "./recaptchaV3-test.vue?vue&type=template&id=e42029da&"
import script from "./recaptchaV3-test.vue?vue&type=script&lang=tsx&"
export * from "./recaptchaV3-test.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports